import trackingQC from "./qc/reducer"

const tracking = { trackingQC }

export default tracking